import { z } from 'zod';

/**
 * Validation for the "Do not sell or share my personal information" form on
 * `/your-privacy-choices`. Shared by the client form (react-hook-form resolver)
 * and the server action so the contract stays in one place.
 *
 * Email is the only field. The opt-out is exercisable with no account and no
 * identity verification, so there is nothing else to ask for — anything more
 * would be a barrier the law does not allow us to put in the way.
 */
export const saleSharingOptOutSchema = z.object({
    email: z
        .string()
        .trim()
        .min(1, 'Enter your email address')
        .email('Enter a valid email address'),
});

export type SaleSharingOptOutValues = z.infer<typeof saleSharingOptOutSchema>;

export const SALE_SHARING_OPT_OUT_DEFAULT_VALUES: SaleSharingOptOutValues = {
    email: '',
};
